import React from "react";
import { ModalBuilder, SignalR } from "@redriver/cinnamon";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { withCurrentUser } from "features/../../../shared/components/auth";
import { guidsAreEqual } from "features/../../../shared/modules/helpers";

const SheetLockedCallbackModal = ({ onSubmit, currentUser }) => {
  const { t } = useTranslation("sheetTranslation", {
    keyPrefix: "SheetLockedNotificationModal",
  });
  const [showModal, setShowModal] = React.useState(false);
  return (
    <React.Fragment>
      <SignalR.Callback
        methodName="SheetLocked"
        callback={(sheetIdArg, userIdArg) => {
          if (!guidsAreEqual(userIdArg, currentUser.id)) {
            setShowModal(true);
          }
        }}
      />
      <ModalBuilder
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onSubmit={() => {
          setShowModal(false);
          onSubmit();
        }}
        renderModal={(modalProps, formProps) => (
          <TranslatedModal.Confirmation {...modalProps} header={t("Header")}>
            {t("ConfirmMessage")}
          </TranslatedModal.Confirmation>
        )}
      />
    </React.Fragment>
  );
};

export default withCurrentUser(SheetLockedCallbackModal);
